<template>
    <div class="foot">
        <div class="container">
            <div class="foot-box">
                <div class="introduce">
                    <p class="title">福分通介绍</p>
                    <div class="content">
                        <p>
                            重庆福分通股份有限公司是欧菲斯办公伙伴集团旗下专业的企业福利服务平台。多年来不断的整合优质供应商资源，运用现代化互联网技术，逐步搭建起一个B2B2C的企业福利云平台，为广大的政企客户提供福利发放、商务礼赠、员工关怀、礼品定制及企业内购等全方位电商化采购服务。自2017年成立至今，福分通已陆续在北京、上海、成都、南京及沈阳等地设立23个分支机构，拥有近千人的服务团队，是一家专业的企业福利综合解决方案提供商。</p>
                    </div>
                </div>
                <div class="friendly-link">
                    <p class="title">友情链接</p>
                    <div class="content">
                        <p><a href="http://www.officemate.cn/">officemate办公伙伴</a></p>
                        <p><a href="http://www.officezzt.com/">增值通</a></p>
                        <p><a href="">维修通</a></p>
                    </div>
                </div>
                <div class="contact-us">
                    <p class="title">联系我们</p>
                    <div class="content">
                        <p>咨询热线：400-870-3700</p>
                        <p>服务时间：工作日上午8：30至下午18：00</p>
                        <p>商务合作：ranfu@officemate.cn</p>
                        <p>供应商合作：zhaoyue@officemate.cn</p>
                        <p><a class="link" href="" style="color: #ddd">帮助中心</a></p>
                    </div>
                </div>
                <div class="dc-code">
                    <img style="margin-left: 40px;margin-top: 20px;" width="100" src="../assets/img/qc.png" alt="">
                    <p style="font-size: 14px;color: white;font-weight: bold;margin-top: 10px;transform: translateX(-6px)"
                       class="ar">福分通公众号</p>
                </div>
            </div>
            <div class="site-num">
                <p>版权所有 © CopyRight 2018 欧菲斯办公伙伴控股有限公司 渝ICP备18008342号-2</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "foot"
    }
</script>

<style scoped lang="stylus">
    .foot
        width 100%
        min-width 1200px
        background-color #000000
        padding 80px 0 40px
        .foot-box
            position relative
            &:after
                display block
                content ''
                clear both
            div
                float left
            p.title
                font-size 16px
                font-weight bold
                color #ddd
                margin-bottom 25px
            div.content
                font-size 14px
                color #ddd
                p
                    line-height 24px
            .introduce
                width 380px
                box-sizing content-box
                padding-right 68px
                border-right 1px solid #555555
            .friendly-link
                width 230px
                padding 0 50px
                .content
                    p
                        line-height 26px
                        vertical-align top
                        a
                            color #ddd
                            &:hover
                                font-weight bold
                                color white
            .contact-us
                width 290px
                height 238px
                box-sizing content-box
                padding-left 50px
                border-left 1px solid #555
        .site-num
            margin-top 50px
            p
                text-align center
                color bbb
                font-size 13px
        .link:hover
            font-weight bold
            color white
</style>